export default __webpack_public_path__ + "static/media/7.181dc6b6.svg";